/** 仅允许移动端访问（印章录入/测试页） */
export function detectMobileAllowed() {
  if (typeof window === 'undefined') return true
  const ua = navigator.userAgent || ''
  const isMobileUa = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
  const isTablet = /iPad|Tablet/i.test(ua)
  const hasTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0
  const narrowScreen = window.innerWidth <= 768

  if (isMobileUa || isTablet) return true
  if (narrowScreen && hasTouch) return true
  return false
}

export const sealMobileOnlyMixin = {
  data() {
    return {
      mobileAllowed: true
    }
  },
  created() {
    this.mobileAllowed = detectMobileAllowed()
  },
  mounted() {
    if (!this.mobileAllowed) return
    this._onSealViewportChange = () => {
      if (typeof this.syncCanvasSize === 'function') {
        this.syncCanvasSize()
      }
    }
    window.addEventListener('resize', this._onSealViewportChange)
    window.addEventListener('orientationchange', this._onSealViewportChange)
  },
  beforeDestroy() {
    if (this._onSealViewportChange) {
      window.removeEventListener('resize', this._onSealViewportChange)
      window.removeEventListener('orientationchange', this._onSealViewportChange)
    }
    if (typeof this._destroySealMobileOnly === 'function') {
      this._destroySealMobileOnly()
    }
  }
}

/** 解析 van-picker @confirm 回传（可能是选项对象、value 或数组） */
export function resolveVanPickerOption(payload) {
  if (payload == null) return null
  let picked = payload
  if (Array.isArray(picked)) {
    picked = picked.length ? picked[0] : null
  }
  if (picked && typeof picked === 'object') {
    if (picked.value != null && picked.value !== '') return picked.value
    if (picked.ruleCode != null) return picked.ruleCode
    if (picked.id != null) return picked.id
    return null
  }
  return picked
}

export function formatSealRuleLabel(rule) {
  if (!rule) return ''
  const code = rule.ruleCode || rule.rule_code || ''
  const remark = (rule.remark || '').trim()
  if (remark && code) return `${remark} (${code})`
  return remark || code || '未命名规则'
}

/** 按当前显示尺寸同步 canvas 内部分辨率 */
export function syncSealCanvasSize(vm) {
  const canvas = vm.$refs.canvas
  if (!canvas) return
  const rect = canvas.getBoundingClientRect()
  const w = Math.max(1, Math.round(rect.width))
  const h = Math.max(1, Math.round(rect.height))
  if (rect.width < 1 || rect.height < 1) return
  if (canvas.width !== w || canvas.height !== h) {
    canvas.width = w
    canvas.height = h
    vm.ctx = canvas.getContext('2d')
  } else if (!vm.ctx) {
    vm.ctx = canvas.getContext('2d')
  }
}
